<template>
    <li class="drop-down_menu" @click="toggle" :class="{'drop-open': active}">
        <a>{{$t('topbar.menu.concept.button').toUpperCase()}}</a>
        <div class="drop-down_container">
            <div class="sub-menu">
                <ul id="concept">
                    <li v-for="(item, index) in menu">
                        <router-link
                                :to="{name: 'concept2', params: {conceptMenuId: item.id, slug: slug(item.text.title)}}"
                                tag="a"
                                class="">{{item.text.title}}</router-link>
                    </li>
                </ul>
            </div>
        </div>
    </li>
</template>

<script>
    import {mapState} from "vuex";
    import {TextHelper} from '../../helpers/text.helper';

    export default {
        name: "concept-menu-mobile",
        computed: {
            ...mapState({
                menu: s => s.menu.concept,
            })
        },
        data() {
          return {
              active: false
          }
        },
        methods: {
            slug(txt) {
              return TextHelper.slugify(txt);
            },
            toggle(e) {
                this.active = !this.active;
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/topbar/concept-menu-mobile.vue